import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import { routerMiddleware } from 'react-router-redux';
import createLogger from 'redux-logger';
import rootReducer from '../reducers';
// import { persistStore, autoRehydrate } from 'redux-persist'

export default function configureStore(history) {
  const reactRouterReduxMiddleware = routerMiddleware(history);
  const debug = process.env.NODE_ENV === 'development';
  const logger = createLogger();

  const middleware = [
    thunk,
    promise,
    debug && logger,
    reactRouterReduxMiddleware
  ].filter(Boolean);

  const store = createStore(
    rootReducer,
    undefined,
    compose(
      applyMiddleware(...middleware),
      typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : f => f
      // autoRehydrate()
    )
  );
  // persistStore(store, {debounce: 100})

  if (module.hot) {
    // Enable hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      // eslint-disable-next-line
      const nextRootReducer = require('../reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./app/store/configureStore.js